import { render } from "./AbilityEdit.vue?vue&type=template&id=a5cea676&lang=true"
import script from "./AbilityEdit.vue?vue&type=script&lang=js"
export * from "./AbilityEdit.vue?vue&type=script&lang=js"
script.render = render

export default script